export const CHEMICAL = {
  // น้ำยางสด
  RAW_LATEX : [
    { chemical: 'NH3', amount: null },
    { chemical: 'VFA', amount: null },
    { chemical: 'TZ', amount: null }
  ],
  // บ่อ
  POND : [
    { chemical: '%TSC', amount: null },
    { chemical: '%DRC', amount: null },
    { chemical: '%NH3', amount: null },
    { chemical: 'Mg', amount: null },
    { chemical: 'NH3', amount: null },
    { chemical: 'VFA', amount: null },
  ],
  // แทงก์
  TANK : [
    { chemical: '%TSC', amount: null },
    { chemical: '%DRC', amount: null },
    { chemical: '%NH3', amount: null },
    { chemical: 'Mg', amount: null },
    { chemical: 'NH3', amount: null },
    { chemical: 'VFA', amount: null },
    { chemical: 'MST', amount: null },
    { chemical: 'pH', amount: null },
    { chemical: 'KOH', amount: null },
    { chemical: 'Sg', amount: null },
    { chemical: '%NRS', amount: null },
    { chemical: '%Coa', amount: null },
    { chemical: 'Visco', amount: null },
    { chemical: 'CST', amount: null },
    { chemical: 'Swell', amount: null },
  ],
    // skim
  SKIM : [
    { chemical: '%DRC', amount: null },
    { chemical: 'NH3', amount: null },
  ],
}

export const CHEMICAL_FILL = {
  // บ่อ
  POND : [
    { chemical: 'NH4OH', amount: null },
    { chemical: 'TZ', amount: null },
    { chemical: 'DAPH', amount: null },
    { chemical: 'H2O', amount: null },
    { chemical: 'LARCS', amount: null },
  ],
  // แทงก์
  TANK : [
    { chemical: '%TSC', amount: null },
    { chemical: '%DRC', amount: null },
    { chemical: '%NH3', amount: null },
    { chemical: 'Mg', amount: null },
    { chemical: 'NH3', amount: null },
    { chemical: 'VFA', amount: null },
  ]
}
const combineChemicals = (chemicals1, chemicals2) => {
  return [...chemicals1, ...chemicals2].reduce((uniqueChemicals, current) => {
    if (!uniqueChemicals.some(item => item.chemical === current.chemical)) {
      uniqueChemicals.push(current);
    }
    return uniqueChemicals;
  }, []);
};
export const COMBINED_CHEMICALS = {
  POND: combineChemicals(CHEMICAL.POND, CHEMICAL_FILL.POND),
  TANK: combineChemicals(CHEMICAL.TANK, CHEMICAL_FILL.TANK),
  RAW_LATEX: CHEMICAL.RAW_LATEX
};
export const DISPENSE_CHEMICAL = {
  TZ: 'TZ',
  NH4OH: 'NH4OH'
}